// extracted by mini-css-extract-plugin
export default {"button":"Fk-z","reviewSort":"Gk-z"};